import axios from "@/plugins/axios";

let url = "/api/v1/portfolios/:_portfolio/bookmark";

export default {
    putBookmark(_portfolio, data){
        return axios.put(`${url.replace(":_portfolio", _portfolio)}`, data).then(result => result.data);
    },
}
